import React, { useEffect, useState } from 'react';

import { Tooltip, Fab } from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  Add,
} from "@mui/icons-material";

import { 
  StartEquipmentChoice, 
} from "@dndModels";

import StartEquipmentChoiceInput from "@dndComponents/equipment/StartEquipmentChoiceInput";

interface Props {
  choices: StartEquipmentChoice[];
  onChange: (choices: StartEquipmentChoice[]) => void; 
  disabled: boolean;
}

export default function StartEquipmentChoices({ 
  choices,
  onChange,
  disabled
}: Props) {
  const [my_choices, setChoices] = useState(choices);
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <span className="header">
          Starting Equipment Choices
        </span>
        { !disabled &&
          <Tooltip title={`Create New Choice`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                const new_choices = my_choices;
                const choice = new StartEquipmentChoice();
                new_choices.push(choice);
                setChoices(new_choices);
                onChange(new_choices);
                setReloading(true);
              }}>
              <Add/>
            </Fab>
          </Tooltip>
        }
      </Grid>
      { !reloading && my_choices.map((choice, key) => { // my_choices
        return (
          <Grid
            key={key}
            size={{
              xs: 12
            }}>
            <div style={{ paddingLeft: "4px", width: "calc(100% - 4px)" }}>
              <StartEquipmentChoiceInput
                choice={choice}
                disabled={disabled}
                onChange={(changed: StartEquipmentChoice) => {
                  const new_choices = my_choices;
                  const choice_finder = new_choices.filter(o => o.id === changed.id);
                  if (choice_finder.length === 1) {
                    const the_choice = choice_finder[0];
                    the_choice.copy(changed);
                    setChoices(new_choices);
                    onChange(new_choices);
                  }
                }}
                onDelete={() => {
                  const new_choices = my_choices.filter(o => o.id !== choice.id);
                  setChoices(new_choices);
                  onChange(new_choices);
                  setReloading(true);
                }}
              />
            </div>
          </Grid>
        );
      }) }
    </Grid>
  );
}
